import React from 'react';
import PropTypes from 'prop-types';
import { checkIfVariantAvailable } from '../../Utils/VariantUtils';

var SelectOption = function SelectOption(props) {
  var selectVariant = checkIfVariantAvailable(props.value, props.name, props.selectedOptions, props.variants);

  return React.createElement(
    'option',
    { key: props.name + '-' + props.value, value: props.value },
    '' + props.value,
    !selectVariant.availableForSale && ' - SOLD OUT'
  );
};

SelectOption.propTypes = {
  selectedOption: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  selectedOptions: PropTypes.object,
  variants: PropTypes.array
};

export default SelectOption;